import { IColumn } from "@fluentui/react";
import { VariantDetail } from "../../../../Types";
import { accessibleTextRenderer } from "../../../../Shared/TableRenderers";
import {
  deleteButtonRenderer,
  editButtonRenderer,
  featureFlagRenderer,
} from "./variantDetailsFormTableColumnRenderers";
const getVariantDetailsColumns = ({
  onDelete,
  onEdit,
  onRemoveFlag,
}: {
  onDelete: (item: VariantDetail) => void;
  onEdit: (item: VariantDetail) => void;
  onRemoveFlag: (item: VariantDetail, flag: string) => void;
}): IColumn[] => [
  {
    key: "name",
    name: "Name",
    fieldName: "name",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
    onRender: (item: VariantDetail) => accessibleTextRenderer(item.name),
  },
  {
    key: "featureFlags",
    name: "Feature Flags",
    fieldName: "featureFlags",
    minWidth: 150,
    flexGrow: 1,
    isResizable: true,
    isMultiline: true,
    onRender: (item: VariantDetail) =>
      featureFlagRenderer(item.featureFlags, (flag: string) =>
        onRemoveFlag(item, flag),
      ),
  },
  {
    key: "delete",
    name: "Delete",
    minWidth: 50,
    maxWidth: 50,
    isResizable: false,
    onRender: (item: VariantDetail) => deleteButtonRenderer(item, onDelete),
  },
  {
    key: "edit",
    name: "Edit",
    minWidth: 30,
    maxWidth: 30,
    isResizable: false,
    onRender: (item: VariantDetail) => editButtonRenderer(item, onEdit),
  },
];

export { getVariantDetailsColumns };
